module.exports = new __parcel__URL__("mario-kart-7.9c7fafd5.jpg").toString();